import { getPlatformStyles } from '@direct-frontend/platform-code';

import { useVStack } from '../../hooks/useStack';
import { cn } from '../../lib/css/className/className';
import { Card } from '../Card';
import { ModalButtons } from '../Modal';
import { VStack } from '../Stack';
import { getSizeSkin } from '../../lib/skin/getSizeSkin/getSizeSkin';

import { OverlayContentProps } from './types';

getPlatformStyles({ mobile: import('./OverlayContent@mobile.css') });

const cls = cn('OverlayContent');

export default function OverlayContent(props: OverlayContentProps) {
    const { children, bottomButtons, bottomLeftControls, mobileBottomButtonsDirection = 'vertical' } = props;
    const sizeSkin = getSizeSkin('m');
    const centerStack = useVStack({ gap: 'current-geometry' });

    let bottomContent = bottomButtons;

    if (bottomLeftControls) {
        bottomContent =
            mobileBottomButtonsDirection === 'vertical' ? (
                <VStack gap="24">
                    {bottomButtons && <VStack gap="8">{bottomButtons}</VStack>}
                    {bottomLeftControls}
                </VStack>
            ) : (
                <>
                    {bottomLeftControls}
                    {bottomButtons}
                </>
            );
    }

    return (
        <Card color="gray-3" className={cls('', [sizeSkin, centerStack])}>
            {children}
            <ModalButtons type={mobileBottomButtonsDirection}>{bottomContent}</ModalButtons>
        </Card>
    );
}
